export interface Region {
  id: string;
  name: string;
}

export interface RegionOption {
  value: string;
  label: string;
}

export const toTitleCase = (str: string) => str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());

/** Opsi dropdown wilayah (Provinsi, Kota/Kabupaten): label Title Case, urut abjad A–Z tanpa memedulikan kapital. */
export const buildRegionOptions = (regions: Region[]): RegionOption[] =>
  regions
    .map(region => ({ value: region.id, label: toTitleCase(region.name) }))
    .sort((a, b) => a.label.localeCompare(b.label, 'id', { sensitivity: 'base' }));
